@let profile = conversation.profile;

<div class="pt-4@r display-flex flex-direction-column align-items-center">
  <sb-profile-photo
    [photoUrl]="profile.profile_photo_url"
    [route]="`/next/profile/${profile.browse_id}`"
    [showFavoriteBadge]="profile.favorited"
    [size]="'xl'"
  />
  <a class="t-6@r color-void mt-2@r font-weight-500" [routerLink]="['/next/profile', profile.browse_id]">
    {{ profile.username }}
    @if (profile.verified) {
      <sb-icon class="color-verified" [name]="'verify'" [secondaryColor]="'white'" />
    }
  </a>
  <div class="color-ash t-7@r mt-1@r">
    {{ profile.age }}
    •
    {{ profile.display_location }}
  </div>
</div>

<div class="pv-4@r grid gap-2@r">
  <div class="profile-photo display-flex justify-self-end align-self-end">
    <sb-profile-photo [photoUrl]="profile.profile_photo_url" [size]="'sm'" />
  </div>

  <div class="message border-radius-20 bg-jet color-white t-6@r pf-3@r position-relative">
    @if (conversation.boosted) {
      <div class="boost-label color-yellow bg-jet border-radius-circle center-flex position-absolute">
        <sb-icon [name]="'flash'" [size]="'8'" />
      </div>
    }
    <div class="font-weight-500">
      {{ profile.username }} sent you
      @if (conversation.locked_messages_count === 1) {
        a
        @if (conversation.boosted) {
          <span class="color-yellow">boosted</span>
        }
        message!
      } @else {
        {{ conversation.locked_messages_count }} Messages
      }
    </div>

    <div class="display-flex justify-content-center position-relative pv-3@r">
      <div class="position-absolute center-absolute pointer-events-none width-full ph-3@r">
        <sb-skeleton class="t-10@r" [variant]="{ type: 'text', lines: 2 }" />
      </div>
      <sb-stamp [size]="'large'" [type]="'fill-semi-transparent-white'">
        <sb-icon [name]="'lock'" />
      </sb-stamp>
    </div>

    <button
      sbButton
      [block]="'all'"
      [processing]="conversationStore.unlockInProgress()"
      [size]="'big'"
      [variant]="'fill-gold'"
      (click)="conversationStore.attemptToUnlockConversation(conversation)"
    >
      Unlock Message
    </button>
  </div>

  <div class="text text-align-center color-iron mt-2@r t-9@r ph-4 pl-0@tablet pr-0@tablet">
    With just {{ profile.costs.unlock_thread }} credits you can reveal
    @if (conversation.locked_messages_count === 1) {
      this message
    } @else {
      these messages
    }
    and send an unlimited number of text messages to {{ profile.username }}.
  </div>
</div>
